// @flow
import { combineReducers } from 'redux';
import actionTypes from '../../lib/constants';

type SummarizedUsagesStateType = {|
  data: Object[],
  failure: boolean,
  fetching: boolean,
  networkFailure?: boolean,
  refreshing: boolean,
|};

export const initialSummarizedUsagesState: SummarizedUsagesStateType = {
  fetching: false,
  failure: false,
  refreshing: false,
  data: [],
};

export const summarizedUsagesReducer = (
  state: SummarizedUsagesStateType = initialSummarizedUsagesState,
  action: Object
) => {
  switch (action.type) {
    case actionTypes.FETCH_USAGES_SUCCESS: {
      const { usages } = action.payload;

      return {
        ...state,
        data: usages,
        fetching: false,
        failure: false,
        networkFailure: false,
      };
    }
    case actionTypes.FETCH_USAGES_FAILURE: {
      const { error } = action;

      return {
        ...state,
        fetching: false,
        failure: true,
        networkFailure: error.url && error.url.includes('networkBucket'),
      };
    }
    default:
      return state;
  }
};

export const detailedUsagesReducer = (state: Object[] = [], action: Object) => {
  switch (action.type) {
    case actionTypes.FETCH_DETAILED_USAGES_SUCCESS:
      return action.payload.detailedUsages;
    default:
      return state;
  }
};

export const usageAggregateReducer = (state: Object[] = [], action: Object) => {
  switch (action.type) {
    case actionTypes.FETCH_USAGE_AGGREGATE_SUCCESS:
      return action.payload.usageAggregate;
    default:
      return state;
  }
};

export const currentUsageReducer = (state: Object = {}, action: Object) => {
  switch (action.type) {
    case 'SELECT_USAGE':
      return action.payload.usage;
    case actionTypes.RESET_USAGE:
    case 'SUBSCRIPTION_FETCH_ALL':
      return {};
    default:
      return state;
  }
};

export const displayModeReducer = (state: string = 'daily', action: Object) => {
  switch (action.type) {
    case actionTypes.UPDATE_USAGE_DISPLAY_MODE:
      return action.payload.mode;
    default:
      return state;
  }
};

export const usageReducer = combineReducers({
  summarizedUsages: summarizedUsagesReducer,
  usageAggregate: usageAggregateReducer,
  detailedUsages: detailedUsagesReducer,
  currentUsage: currentUsageReducer,
  displayMode: displayModeReducer,
});
